import { jsxs as n, jsx as t } from "react/jsx-runtime";
import { withManagedProps as c } from "@made-people/managed-props";
import { z as e } from "zod";
import { withZod as d } from "@made-people/react-prop-guard";
import { template1Styling as S } from "./index-blueprint.es.js";
import { componentWrapperSchema as s, ComponentWrapper as T } from "@made-people/blueprint-component-wrapper";
import { responsiveImageSchema as v, ResponsiveImage as N } from "@made-people/blueprint-responsive-image";
import { mediaSchema as w, Media as y } from "@made-people/blueprint-media";
import { headingSchema as A, Heading as I } from "@made-people/blueprint-heading";
import { badgeSchema as b, Badge as j } from "@made-people/blueprint-badge";
import { Markdown as M } from "@made-people/blueprint-markdown";
import "@made-people/blueprint";
const g = e.object({
  template: e.literal("template1"),
  layout: s.shape.layout.optional(),
  variants: e.custom().optional(),
  text: e.string().optional(),
  /**
   * @deprecated Please avoid using 'image' going forward. Use 'media' instead.
   */
  image: v.optional(),
  media: w.optional(),
  heading: A.optional(),
  link: e.object({
    label: e.string().optional(),
    href: e.string().optional()
  }).optional(),
  badge: b.optional(),
  children: e.custom().optional()
  // Used for arbitrary CTAs
}).merge(s), P = c(
  "ImageAndTextTemplate1",
  d(
    {
      schema: g,
      defaultProps: { template: "template1" }
    },
    ({
      variants: m,
      text: l,
      heading: r,
      link: o,
      layout: h,
      image: f,
      media: i,
      badge: p,
      children: u,
      ...x
    }) => {
      const a = S.main.styles(m);
      return /* @__PURE__ */ n(
        T,
        {
          className: a.wrapper,
          ...x,
          layout: { ...h },
          children: [
            /* @__PURE__ */ t("div", { className: a.imageWrapper, children: i ? /* @__PURE__ */ t(
              y,
              {
                ...i,
                image: {
                  displaySize: {
                    mobile: "100vw",
                    desktop: "50vw"
                  },
                  ...i.image
                },
                className: a.image
              }
            ) : /* @__PURE__ */ t(N, { ...f, className: a.image }) }),
            /* @__PURE__ */ n("div", { className: a.content, children: [
              (p == null ? void 0 : p.label) && /* @__PURE__ */ t(j, { ...p }),
              (r == null ? void 0 : r.heading) && /* @__PURE__ */ t(I, { ...r }),
              l && /* @__PURE__ */ t(M, { content: l, className: a.text }),
              u
            ] }),
            (o == null ? void 0 : o.label) && /* @__PURE__ */ t("p", { className: a.link, children: o == null ? void 0 : o.label })
          ]
        }
      );
    }
  )
), W = e.discriminatedUnion("template", [
  g
]), J = c(
  "ImageAndText",
  d(W, (m) => m.template === "template1" ? /* @__PURE__ */ t(P, { ...m }) : null)
);
export {
  J as ImageAndText,
  P as ImageAndTextTemplate1,
  W as imageAndTextPropsSchema,
  g as imageAndTextTemplate1Schema
};
//# sourceMappingURL=index.es.js.map
